import { palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const StyledDatePicker = styled.div`
  ${typography.body_large_regular};

  & .MuiInputBase-input .MuiOutlinedInput-input {
    text-transform: lowercase;
  }

  & .MuiInputBase-root.Mui-focused > input {
    text-transform: lowercase;
  }

  & .MuiInputBase-colorPrimary.Mui-focused > .MuiOutlinedInput-notchedOutline {
    border-color: ${palette.colors.green_base} !important;
  }
`;
